import React, { useEffect, useState } from "react";
import { IconType } from "react-icons";
import { GoChevronLeft, GoChevronDown } from "react-icons/go";

function ServiziListElement(
  content: Readonly<{
    Icon: IconType;
    Title: string;
    Description: string;
  }>
) {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenClose = () => setIsOpen(!isOpen);
  
  return (
    <div className="pt-[2%] pb-[2%]">
      <div className="flex  items-center justify-between  text-xl md:text-2xl lg:text-3xl 2xl:text-4xl ">
        {/* <span className="flex items-center"> */}
          <p><content.Icon /></p>
          <p className="pl-[2%] grow"> {content.Title}</p>
        {/* </span> */}
        {!isOpen && (
          <button onClick={handleOpenClose} className=" ease-in-out delay-2000">
            <GoChevronLeft />
          </button>
        )}
        {isOpen && (
          <button onClick={handleOpenClose} className=" ease-in-out delay-2000">
            <GoChevronDown />
          </button>
        )}
      </div>
      {isOpen && (
        <p className="transition-all ease-in-out duration-300  p-[3%]">
          {content.Description}
        </p>
      )}
    </div>
  );
}

export default ServiziListElement;
